<div class="universal-error-modal">
  <h1 class="universal-error-modal__title">Something went wrong!</h1>
  <div class="universal-error-modal__content">
    Unfortunately we cannot find an active account for this particular portal
    and company. Please check you're using the correct login details, or link
    and try again.
    <br />
    Alternatively, if you need help please call us on the telephone number for
    your area.
    <br />
    <br />
    Thornbury Nursing Services -
    <a class="text-link" href="tel:0345 120 5251">0345 120 5251</a>
    <br />
    Scottish Nursing Guild, Scotland -
    <a class="text-link" href="tel:0131 221 7178">0131 221 7178</a>
    <br />
    Scottish Nursing Guild, Northern Ireland -
    <a class="text-link" href="tel:0131 221 7178">0131 221 7178</a>
    <br />
    Scottish Nursing Guild, Republic of Ireland -
    <a class="text-link" href="tel:01 902 3083">01 902 3083</a>
    <br />
    <br />
    <a class="text-link" [href]="dashboardUrl" target="_blank"
      >View all our portals here</a
    >
  </div>
  <div class="universal-error-modal__actions">
    <div class="universal-error-modal__actions__button">
      <ui-button
        (handleClick)="closeModal($event)"
        [isSecondary]="true"
        buttonClassName="button-full-width"
        buttonId="universal-error-modal-close"
        buttonText="Close"
        gtmTag="universal-error-modal-close"
      ></ui-button>
    </div>
  </div>
</div>
